import HistoryIcon from './HistoryIcon/HistoryIcon';
import MonitorWarningIcon from './MonitorWarningIcon/MonitorWarningIcon';
import MyStakesIcon from './MyStakesIcon/MyStakesIcon';
import NoItemsIcon from './NoItemsIcon/NoItemsIcon';
import PaperPlaneIcon from './PaperPlaneIcon/PaperPlaneIcon';
import PaymentIcon from './PaymentIcon/PaymentIcon';
import PortfolioIcon from './PortfolioIcon/PortfolioIcon';
import TicketIcon from './TicketIcon/TicketIcon';

export {
  NoItemsIcon,
  TicketIcon,
  HistoryIcon,
  PortfolioIcon,
  MyStakesIcon,
  PaperPlaneIcon,
  PaymentIcon,
  MonitorWarningIcon,
};
